// import Chartist from 'chartist';

function visibilityObserver() {
    return {
        visible: true,

        observe(observableElem) {
            if (!window.IntersectionObserver) return;
            const observer = new IntersectionObserver(((entries) => {
                entries.forEach((entry) => {
                    this.visible = entry.isIntersecting;
                });
            }));

            observer.observe(observableElem);
        },
    };
}

// function chartistBarChart(element, data) {
//     const options = {
//         axisX: {
//             showGrid: false,
//         },
//         axisY: {
//             scaleMinSpace: 40,
//             labelInterpolationFnc(value) {
//                 return `${value}%`;
//             },
//         },
//     };
//     // eslint-disable-next-line no-new
//     new Chartist.Bar(element, data, options);
// }

function employerQuiz(data) {
    return {
        ...data,
        sessionId: Math.random().toString(36).substring(7),

        activeQuiz: data.quiz.find((q) => q.id === 1),
        matchingResult: null,

        confirmAnswer() {
            this.postAnswer(this.activeQuiz);

            if (this.activeQuiz.id === this.quiz[this.quiz.length - 1].id) {
                this.matchResult();
                this.activeQuiz = null;
            } else {
                this.activeQuiz = this.quiz.find((q) => q.id === this.activeQuiz.id + 1);
                this.matchingResult = null;
            }
        },

        postAnswer(quiz) {
            window.axios.post('/company/steps', {
                session_id: this.sessionId,
                step: quiz.id,
                value: (quiz.id === 4) ? undefined : quiz.answer,
                category_id: (quiz.id === 4) ? quiz.answer : undefined,
            });
        },

        resetQuiz() {
            Object.keys(this.quiz).forEach((key) => {
                this.quiz[key].answer = null;
            });
            this.activeQuiz = this.quiz.find((q) => q.id === 1);
            this.matchingResult = null;
        },

        ctaAction(cta) {
            if (cta.action === 'INTERCOM_SHOWNEWMESSAGE') {
                // eslint-disable-next-line no-undef
                Intercom('showNewMessage');
            } else {
                window.location.assign(cta.action);
            }
        },

        matchResult() {
            const answerCode = Object.values(this.quiz)
                .filter((question) => question.answer !== null)
                .map((question) => question.answer)
                .join('.');

            this.matchingResult = this.results
                .find((answer) => answer.answerCodes.find((ac) => answerCode.includes(''.concat(ac, '.')))) || null;
        },
    };
}

/**
 * Reconsider this when Alpine V3 will have components.
 */
export default {
    init() {
        window.alpine = {
            visibilityObserver,
            // chartistBarChart,
            employerQuiz,
        };
    },
};
